import React from "react";
import SuggestionsBlock from "components/SuggestionsBlock";
import QnA from "./Q&A";
import CourseList from "./CourseList/index";
import FacultyPhotos from "./FacultyPhotos/index.jsx";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import Divider from "components/common/Divider";
import { ApplyBlock } from "components/ApplyNow/ApplyBlock";
import CourseSection from "./CourseSection";
import ReportProblem from "pages/Block/ReportProblem";

const AcademyDesktop = () => {
  const { dir } = useAppSelector(getSettings);
  const [selectedCourse, setSelectedCourse] = React.useState({});

  return (
    <section className={"flex flex-col gap-6 lg:gap-12"}>
      <div dir={dir} className={`flex justify-between container`}>
        <div className={"w-full lg:w-[calc(50%-30px)]"}>
          <CourseList
            setSelectedCourse={setSelectedCourse}
            selectedCourse={selectedCourse}
          />
          <div className="bg-theme-blue mt-14 relative flex justify-center">
            <div
              className="triangle rotate-180 absolute"
              style={{
                borderWidth: "0 1rem 1rem 1rem",
                borderColor: "transparent transparent white transparent",
              }}
            />
            <ApplyBlock />
          </div>
        </div>
        <div className={`fixed lg:relative w-screen lg:w-[calc(50%-30px)] h-screen lg:h-auto top-0 left-0 bg-[#5A70E8] lg:bg-white z-10 flex lg:block items-center justify-center ${
           selectedCourse?._id ? "block" : "lg:block hidden"
        }`}>
          <div
            className={`w-[92%] max-h-[90%] lg:max-h-auto lg:w-full overflow-y-auto lg:overflow-y-visible bg-white rounded-tl-[27px] rounded-tr-[27px] lg:relative ${
              selectedCourse?._id ? "block" : "lg:block hidden"
            }`}
          >
            <CourseSection
              selectedCourse={selectedCourse}
              setSelectedCourse={setSelectedCourse}
            />
          </div>
        </div>
      </div>
      <Divider className="mx-auto  container" />
      <div
        dir={dir}
        className={`flex flex-col lg:flex-row justify-between container`}
      >
        <div className={"w-full lg:w-[calc(50%-30px)]"}>
          <QnA />
        </div>
        <div className={"w-full lg:w-[calc(50%-30px)] mt-8 lg:mt-0"}>
          <FacultyPhotos />
        </div>
      </div>
      <Divider className="mx-auto  container" />
      <ReportProblem className="-mb-8" />
      <SuggestionsBlock />
    </section>
  );
};

export default AcademyDesktop;
